/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ChatMessageType {
    Message = '0',
    TicketStateChange = 1,
    ChatStarted = 2,
    AddedChatMember = 3,
    RemovedChatMember = 4,
}
